<main id="content-page">
    <div class="main-panel">
        <app-header-ad [position]="'top'"></app-header-ad>

        <app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>
        <div class="row article-row">
            <div class="col-lg-12 col-md-12 col-sm-12">
                <div class="article-wrap">
                    <div *ngIf="containsData()" class="row article-row">
                        <div class="col-lg-12 col-md-12 col-sm-12">
                            <div *ngFor="let item of questions; let i=index">
                                <app-quiz-question [item]="item" [itemNum]="i"></app-quiz-question>
                            </div>
                            <div class="row margin-top-10">
                                <div class="col-lg-9 col-md-9 col-sm-12 article-column">
                                    <div style="margin-top: 10px;">
                                        <button (click)="endTest()" id="backBtn" class="btn btn-primary btn-lg" type="button">back to entry</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <app-header-ad [position]="'bottom'"></app-header-ad>
    </div>
</main>    